import OffersPage from 'components/pages/OfferPages';

import { resolvify } from 'lib/promises';
import { offerQueryKeys } from 'lib/queryKeys';

import { getAds } from 'services/ads';
import { getTagArticlesList } from 'services/article';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getInternationalOffersList, getTopOffersList } from 'services/offer';
import { getStoresList } from 'services/store';

import APP from 'constants/app';
import LINKS from 'constants/links';

const GA_EVENT_CATEGORY = 'international_offer_page';
const OFFERS_FILTER_VALUE = 'international';
const OFFERS_SERVER_LIMIT = 24;
const HEADING_TITLE = 'Ofertas Internacionais';
const PAGE_TITLE =
  'Promoções e Ofertas Internacionais (Itens para Importação) | Promobit.';
const RELATED_ARTICLES_LIMIT = 3;
const LOWEST_PRICE_OFFERS_LIMIT = 5;

const Doubleeleven = (props) => (
  <OffersPage
    apiEndpointRequestFn={(...rest) => getInternationalOffersList(...rest)}
    gaEventCategory={GA_EVENT_CATEGORY}
    headingTitle={HEADING_TITLE}
    offersListProps={{ showButtonBeforeFirstPagination: true }}
    pageTitle={PAGE_TITLE}
    queryKey={(offersSort) =>
      offerQueryKeys.listFilteredBy({
        value: OFFERS_FILTER_VALUE,
        offersSort,
      })
    }
    {...props}
  />
);

export const getServerSideProps = async ({ query }) => {
  try {
    const [
      internationalOffers,
      { offers: topOffers },
      { articles: relatedArticles },
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      {
        data: {
          topAd: [topbarAd = null],
          topbarHighlight: navbarAds,
        },
      },
    ] = await resolvify([
      getInternationalOffersList({ limit: OFFERS_SERVER_LIMIT, ...query }),
      {
        fn: getTopOffersList({ limit: LOWEST_PRICE_OFFERS_LIMIT }),
        fallback: getTopOffersList.fallback,
      },
      {
        fn: getTagArticlesList({
          tagSlug: 'gratis',
          limit: RELATED_ARTICLES_LIMIT,
        }),
        fallback: getTagArticlesList.fallback,
      },
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getAds(),
        fallback: getAds.fallback,
      },
    ]);

    return {
      props: {
        relatedArticles,
        serverOffers: internationalOffers,
        sidebarProps: { topOffers },
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          navbarAds,
          stores,
          topbarAd,
        },
      },
    };
  } catch {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }
};

export default Doubleeleven;
